// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import cookies from 'vue-cookies'
import App from './App'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'static/css/ywtb_main.css'
// import router from "./router.js"
import router from "./router_qh.js"
//引入axios工具类
import https from './api/http_util'
import inactivityTimer from './api/inactivityTimer';
var qs = require('qs');
import util from './util.js'
import VueLazyLoad from 'vue-lazyload'

Vue.use(VueLazyLoad);
Vue.use(ElementUI)
Vue.config.productionTip = false;
Vue.prototype.$util = util;
Vue.prototype.$qs = qs;
Vue.prototype.$https = https;
Vue.prototype.$cookies = cookies;
Vue.use(inactivityTimer);
const thisUrl = location.href.split('#')[0];

Array.prototype.indexOf = function(val) {
  for (var i = 0; i < this.length; i++) {
    if (this[i] == val) return i;
  }
  return -1;
};
Array.prototype.remove = function(val) {
  var index = this.indexOf(val);
  if (index > -1) {
    this.splice(index, 1);
  }
};

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js